module.exports = __webpack_public_path__ + "img/13.b91aee1b.jpg";